import React, { useEffect, useState } from "react";
import Header from "../layout/Header";
import Main from "../layout/Main";
import axios from "axios";
import Footer from "../layout/Footer";

export default function Home() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetch("/data.json")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data.products);
        setCategories(data.categories);
      })
      .catch((err) => console.error("Error al leer JSON:", err));
  }, []);

  const handleDelete = (id) => {
    setProducts((prev) => prev.filter((p) => p.id !== id));
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <Main
        products={products}
        categories={categories}
        onDelete={handleDelete}
      />
        
      <Footer />
    </div>
  );
}